import React, { Dispatch, SetStateAction } from 'react';

import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';

interface OutOfServiceCheckboxProps {
  outOfService: boolean;
  setOutOfService: Dispatch<SetStateAction<boolean>>;
}

const OutOfServiceCheckbox: React.FC<OutOfServiceCheckboxProps> = (props) => {
  const { outOfService, setOutOfService } = props;

  return (
    <Grid container style={{ padding: '1% 2%' }}>
      <FormControlLabel
        control={
          <Checkbox
            checked={outOfService}
            onChange={() => setOutOfService(!outOfService)}
            name="notification_settings"
            color="primary"
          />
        }
        label="Device no longer in service"
      />
    </Grid>
  );
};

export default OutOfServiceCheckbox;
